<div class="offline-message-container">
    <div class="offline-message-icon">
        <i aria-hidden="true" class="fa fa-power-off"></i><br/>
        <span class="offline-message-icon-text">
            Offline-Version
        </span>
    </div>
    <div class="offline-message">
        <p>
            Diese Funktion steht in der Offline-Version nicht zur Verfügung.<br/>
            Stellen Sie eine Internetverbindung her und öffnen Sie den Link zum Buch.
        </p>
        <a class="btn btn-sm btn-open btn-inverse btn-semibold btn-round" href="{{ routeService.getBookListLink() }}"><i
                aria-hidden="true" class="fa fa-caret-left"></i> Zur Buchliste</a>
        <a class="btn btn-sm btn-open btn-semibold btn-round" href="{{ routeService.getBookLink() }}">Zum
            Online-Buch</a>
    </div>
</div>